<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('clientes')">Clientes</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Detalhes
    </h1>
    <div class="w-full grid sm:grid-cols-3 gap-6 xl:gap-8">
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">Razão Social</h3>
        <p class="text-sm ">{{ cliente.razaoSocial }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">Nome Fantasia</h3>
        <p class="text-sm">{{ cliente.nomeFantasia }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">CPF/CNPJ</h3>
        <p class="text-sm">{{ cliente.cpfCnpj }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">Logradouro</h3>
        <p class="text-sm">{{ cliente.logradouro }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">Bairro</h3>
        <p class="text-sm">{{ cliente.bairro }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">Número</h3>
        <p class="text-sm">{{ cliente.numero }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">Cidade</h3>
        <p class="text-sm">{{ cliente.cidade.cidade }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">UF</h3>
        <p class="text-sm">{{ cliente.cidade.uf }}</p>
      </div>
      <div class="flex-auto">
        <h3 class="font-bold text-gray-900 py-2">CEP</h3>
        <p class="text-sm">{{ cliente.cep }}</p>
      </div>
    </div>
    <div class="w-full ">
      <div class="w-10 py-2">
        <a :href="rota" target="_blank" class="w-20 flex-col justify-center  cursor-pointer">
          <rota-icon class="w-10 " />
          <span class="py-1">Rotas</span>
        </a>
      </div>
    </div>

    <div class="w-full py-2">
      <h2 class="font-semibold  text-2xl">Licenças</h2>
      <ul class="flex flex-col space-y-2">
        <item-licence v-for="licenca in cliente.licencas" :key="licenca.idLicenca" class="item-licence" :licenca="licenca" />
      </ul>
    </div>
    <div class="w-full py-2">
      <h2 class="font-semibold  text-2xl">Últimos 10 atendimentos</h2>
      <ul class="flex flex-col space-y-2">
        <item-rac v-for="rac in cliente.racs" :key="rac.idRac" class="item-licence" :rac="rac" />
      </ul>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import RotaIcon from '../../Shared/RotaIcon.vue'
import ItemLicence from '../../Shared/ItemLicence.vue'
import ItemRac from '../../Shared/ItemRac.vue'

export default {
  components: { RotaIcon, ItemLicence, ItemRac },
  metaInfo() {
    return { title: this.cliente.razaoSocial ?? 'Nada' }
  },
  layout: Layout,
  props: {
    cliente: Object,
  },
  data() {
    return {}
  },
  computed:{
    rota() {
      const addres = []
      if(this.cliente.logradouro){
        addres.push(this.cliente.logradouro)
      }
      if(this.cliente.bairro){
        let numero = this.cliente.numero
        if(!numero){
          numero = ''
        }else {
          numero += ' - '
        }
        addres.push(`${numero} ${this.cliente.bairro}`)
      }

      if(this.cliente.cidade.cidade){
        addres.push(`${this.cliente.cidade.cidade} -  ${this.cliente.cidade.uf}`)
      }

      if(this.cliente.cep){
        addres.push(this.cliente.cep)
      }

      return `https://maps.google.com/maps?q=${addres.join(', ')}`
    },
  },
  methods: {
  },
}
</script>

<style>
 .item-licence{
     padding-bottom: 10px;
 }
</style>
